import { render } from "./ResetPassword.vue?vue&type=template&id=0bb8935f&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=0bb8935f&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=0bb8935f&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb8935f"]])

export default __exports__